<script lang="ts">
    import { formatNumberWithSeparators } from '../../../../functions';
    class PersonaleDipendente {
        numeroPersonaleFullTime: number = 0;
        numeroPersonaleFullTimeDonne: number = 0;
        numeroPersonaleFullTimeUomini: number = 0;
        numeroOreContrattoFullTime: number = 0;
        numeroPersonalePartTime: number = 0;
        numeroPersonalePartTimeDonne: number = 0;
        numeroPersonalePartTimeUomini: number = 0;
        formePartTime: string = 'NA';
        numeroPersonaleEsterno: number = 0;
        ordineGradoSedeScuola: string = '';
        numeroStudenti: number = 0;
        lavoratoriItineranti: string = '';

        constructor(init?: PersonaleDipendente) {
            Object.assign(this, init);
        }
    }

    export let data: PersonaleDipendente = new PersonaleDipendente();

    function isAnyFieldSet(): boolean {
            return (data?.numeroPersonaleFullTime > 0 ||
                    data?.numeroPersonaleFullTimeDonne > 0 ||
                    data?.numeroPersonaleFullTimeUomini > 0 ||
                    data?.numeroOreContrattoFullTime > 0 ||
                    data?.numeroPersonalePartTime > 0 ||
                    data?.numeroPersonalePartTimeDonne > 0 ||
                    data?.numeroPersonalePartTimeUomini > 0 ||
                    data?.numeroPersonaleEsterno > 0 ||
                    data?.numeroStudenti > 0 ||
                    data?.formePartTime !== 'NA' && data?.formePartTime?.trim() !== '' ||
                    data?.ordineGradoSedeScuola.trim() !== '' ||
                    data?.lavoratoriItineranti.trim() !== '') && data !== null;
        }
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="text-center border border-black">Numero totale di dipendenti</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{formatNumberWithSeparators((data?.numeroPersonaleFullTime + data?.numeroPersonalePartTime + data?.numeroPersonaleEsterno)) || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Numero personale dipendente tempo pieno</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{formatNumberWithSeparators(data?.numeroPersonaleFullTime) || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Numero personale dipendente part time</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{formatNumberWithSeparators(data?.numeroPersonalePartTime) || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Numero personale esterno</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{formatNumberWithSeparators(data?.numeroPersonaleEsterno) || '-'}</td>
        </tr>
    </tbody>
</table>